import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import config, { Config } from 'config/config';

import { Theme, Languages } from 'types';

const initialState: Config = config;

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    updateConfig(state: Config, action: PayloadAction<Config>) {
      state = {
        ...state,
        ...action.payload,
      };
    },
    updateSiteTheme(state: Config, action: PayloadAction<Theme>) {
      state.theme = action.payload;
      localStorage.setItem(Theme.LocalStorageThemeItem, action.payload);
    },
    setCountryBlacklist(state: Config, action: PayloadAction<boolean>) {
      state.countryBlacklist = action.payload;
    },
    setMaintenance(state: Config, action: PayloadAction<{ maintenance_mode: boolean; maintenance_message: string }>) {
      const { maintenance_mode, maintenance_message } = action.payload;
      state.maintenance = {
        maintenanceMode: maintenance_mode,
        maintenanceMessage: maintenance_message,
      };
    },
    setLanguage(state: Config, action: PayloadAction<Languages>) {
      state.currentLanguage = action.payload;
    },
  },
});

export const { updateConfig, updateSiteTheme, setCountryBlacklist, setMaintenance, setLanguage } = configSlice.actions;

export default configSlice.reducer;
